import {
  Boolean,
  String,
  Dictionary,
  Array,
  Literal,
  Number,
  Record,
  Undefined,
  Union,
  Static,
} from 'runtypes'

const BaseGroup = Record({
  id: String,
  slug: String.Or(Undefined),
  title: String,
  description: String,
  url: String,
  image_url: String,
  access: Union(Literal('open'), Literal('approved'), Literal('closed')),
  verification_status: Union(Literal('verified'), Literal('unverified')),
})

export const BasicGroup = BaseGroup.And(
  Record({
    type: Literal('group'),
  })
)

export type BasicGroup = Static<typeof BasicGroup>

export const BasicGroupWithStats = BasicGroup.And(
  Record({
    type: Literal('group'),
    cases_count: Number,
    member_count: Number,
    cases_count_label: String,
    member_count_label: String,
  })
)

export type BasicGroupWithStats = Static<typeof BasicGroupWithStats>

export const BasicGroupWithPermissions = BasicGroup.And(
  Record({
    can_create_case: Boolean,
    can_post_to_feed: Boolean,
  })
)

export type BasicGroupWithPermissions = Static<typeof BasicGroupWithPermissions>

export const BasicGroupEntry = Record({
  target: BasicGroup.And(Record({ _fullyLoaded: Boolean.Or(Undefined) })),
})

export type BasicGroupEntry = Static<typeof BasicGroupEntry>

export const BasicInstitution = BaseGroup.And(
  Record({
    type: Literal('institution'),
  })
)

export type BasicInstitution = Static<typeof BasicInstitution>

export const isBasicGroup = (group: unknown): group is BasicGroup => {
  return (
    typeof group === 'object' &&
    group !== null &&
    group.hasOwnProperty('id') &&
    group.hasOwnProperty('type') &&
    (group as any).type === 'group'
  )
}

export const isGroupWithStats = (
  group: unknown
): group is BasicGroupWithStats => {
  return (
    typeof group === 'object' &&
    group !== null &&
    ('cases_count_label' in group || 'member_count_label' in group)
  )
}
